import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const intezer = defineConnector({
  identifier: "intezer",
  name: "Intezer",
  tagLine: "Automated malware analysis",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://analyze\\.intezer\\.com/.*",
  auth: (app) =>
    fetchTokenAuth({
      request: {
        url: "https://analyze.intezer.com/api/v2-0/get-access-token",
        jsonBody: {
          api_key: app.secret.apiKey,
        },
      },
      extract: { from: "jsonPath", paths: ["result"] },
      apply: { kind: "header", scheme: "Bearer" },
    }),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to [Intezer Analyze](https://analyze.intezer.com/) and navigate to **Account Settings** to find your API key.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "Intezer API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://analyze.intezer.com/api/v2-0/account",
  },
});
